import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice, faUser } from '@fortawesome/free-solid-svg-icons';
import rankName from '../../utils/user/rankName';

/** Positions 4-10 get cash prize, 11-20 get lucky spin */
const getPrize = (index) => {
    if (index < 7) return { label: '+100.000đ', className: 'text-orange-500' };
    return { label: '50K', className: 'text-purple-500', isLucky: true };
};

/** Highlight top 4, 5, 6 rows slightly */
const ROW_ACCENT = {
    0: 'bg-amber-50 border-amber-100',
    1: 'bg-surface-sunken border-line',
    2: 'bg-orange-50 border-orange-100',
};

function LeaderboardRow({ user, index, onOrdersClick }) {
    const rank = index + 4;
    const prize = getPrize(index);
    const rowBg = ROW_ACCENT[index] || 'bg-surface border-line';
    const hasUser = user?.userId && user.userId !== '-';

    return (
        <div className={`flex items-center gap-2.5 border ${rowBg} rounded-xl px-3 py-2 shadow-sm`}>
            {/* Rank number */}
            <div className="w-6 text-center font-bold text-sm text-content-3 flex-shrink-0">
                {rank}
            </div>

            {/* Avatar */}
            <div className="w-9 h-9 rounded-full bg-surface-muted overflow-hidden flex items-center justify-center flex-shrink-0">
                {user?.userInfo?.avatar ? (
                    <img
                        className="w-full h-full object-cover"
                        src={`${process.env.REACT_APP_API_PUBLIC_URL}/img/users/${user.userInfo.avatar}`}
                        alt="avt"
                    />
                ) : (
                    <FontAwesomeIcon icon={faUser} className="text-content-3 text-sm" />
                )}
            </div>

            {/* Name & rank tag */}
            <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold line-clamp-1">
                    {user?.userInfo ? (user.userInfo.name || `user-${user.userId}`) : '---'}
                </p>
                <div className="scale-90 origin-left inline-block leading-none mt-0.5">
                    {user?.userInfo && rankName(user.userInfo.rank)}
                </div>
            </div>

            {/* Orders count */}
            <div
                className={`text-xs font-semibold text-right ${hasUser ? 'text-primary-600 cursor-pointer hover:underline' : 'text-content-3'}`}
                onClick={() => hasUser && onOrdersClick?.(user)}
            >
                {user?.totalOrders || 0} đơn
            </div>

            {/* Prize */}
            <div className={`text-xs font-bold text-right w-16 flex-shrink-0 ${prize.className}`}>
                {prize.isLucky
                    ? <span><FontAwesomeIcon icon={faDice} /> {prize.label}</span>
                    : prize.label
                }
            </div>
        </div>
    );
}

function Top4Orders({ users, onOrdersClick }) {
    return (
        <div className="px-3 pb-2">
            <h3 className="font-bold text-sm text-center text-content-2 mb-2 pt-1">📋 Bảng xếp hạng</h3>
            <div className="flex flex-col gap-1.5">
                {users.map((user, index) => (
                    <LeaderboardRow
                        key={index}
                        user={user}
                        index={index}
                        onOrdersClick={onOrdersClick}
                    />
                ))}
            </div>
        </div>
    );
}

export default Top4Orders;
